import multiguard from 'vue-router-multiguard';

import Login from '@/components/auth/Login'
import PasswordReset from '@/components/auth/PasswordReset'
import PasswordResetFinal from '@/components/auth/PasswordResetFinal'

import StringerLayout from '@/components/user/Layout.vue'
import StringerDashboard from '@/components/user/Dashboard.vue'
import StringerUpload from '@/components/user/Upload.vue'
import StringerAnnouncements from '@/components/user/Announcements.vue'
import StringerAnnouncementView from '@/components/user/AnnouncementView.vue'
import StringerVideos from '@/components/user/Videos.vue'
import StringerPhotos from '@/components/user/Photos.vue'
import StringerSales from '@/components/user/Sales.vue'
import StringerLiveStormChasing from '@/components/user/LiveStormChasing.vue'
import StringerSupportTickets from '@/components/user/support/Tickets.vue'
import StringerSupportViewTicket from '@/components/user/support/ViewTicket.vue'
import StringerSupportCreateTicket from '@/components/user/support/CreateTicket.vue'
import StringerSettings from '@/components/user/Settings.vue'
import StringerOauth from '@/components/user/Oauth.vue'

import AdminLayout from '@/components/admin/Layout.vue'
import AdminFullWidthLayout from '@/components/admin/FullWidthLayout.vue'
import AdminDashboard from '@/components/admin/Dashboard.vue'
import AdminUpcoming from '@/components/admin/UpcomingVideos.vue'
import AdminVideoManager from '@/components/admin/VideoManager.vue'
import AdminUsers from '@/components/admin/users/Users.vue'
import AdminActiveUsers from '@/components/admin/users/ActiveUsers.vue'
import AdminUserDetails from '@/components/admin/users/UserDetails.vue'

import AdminVideoAddSale from '@/components/admin/sales/video/AddSale.vue'
import AdminVideoSearchSale from '@/components/admin/sales/video/SearchSale.vue'
import AdminVideoSalesCompleted from '@/components/admin/sales/video/Completed.vue'
import AdminVideoSalesPending from '@/components/admin/sales/video/Pending.vue'
import AdminVideoSalesProcessing from '@/components/admin/sales/video/Processing.vue'

import AdminAnnouncements from '@/components/admin/tools/Announcements.vue'
import AdminAnnouncement from '@/components/admin/tools/Announcement.vue'
import AdminTools from '@/components/admin/tools/AdminTools.vue'
import AdminToolsUploadServers from '@/components/admin/tools/UploadServers.vue'
import AdminToolsMediaMailer  from '@/components/admin/tools/MediaMailer.vue'
import AdminAutoApprovalSystem from '@/components/admin/tools/AutoApprovalSystem.vue'
import AdminNetworkManager from '@/components/admin/tools/NetworkManager.vue'
import AdminSupportTickets from '@/components/admin/support/Tickets.vue'
import AdminSupportIndividualTicket from '@/components/admin/support/IndividualTicket.vue'
import AdminSupportKnowledgeBase from '@/components/admin/support/KnowledgeBase.vue'

import MediaLayout from '@/components/media/Layout.vue'
import MediaLatestContent from '@/components/media/Latest.vue'
import MediaPurchases from '@/components/media/Purchased.vue'
import MediaMembers from '@/components/media/Members.vue'
import MediaSearchContent from '@/components/media/Search.vue'
import MediaStreamPlayer from '@/components/media/StreamPlayer.vue'

import AccountSetupLayout from '@/components/account-setup/Layout.vue'
import FinalizeTerms from '@/components/account-setup/Terms.vue'
import FinalizeAccount from '@/components/account-setup/Account.vue'
import FinalizeAbout from '@/components/account-setup/About.vue'
import FinalizeSocial from '@/components/account-setup/Social.vue'
import FinalizeComplete from '@/components/account-setup/Complete.vue'

import ChangeLog from '@/components/general/ChangeLog.vue'
import Metrics from '@/components/general/Metrics.vue'

import MediaPreview from '@/components/media-preview/Preview.vue'
import MediaPreviewV2 from '@/components/media-preview/PreviewV2.vue'

import Guard from '@/router/middleware';

export default [
    {
        path: '/',
        name: 'DashboardRedirect',
        redirect: '/dashboard',
        beforeEnter: multiguard([Guard.auth, Guard.verifyUserNotSuspended, Guard.verifyUserAcceptedTerms]),
    },
    {
        path: '/dashboard',
        name: 'DashboardRedirect',
        beforeEnter: multiguard([Guard.auth, Guard.goToDashboard, Guard.verifyUserAcceptedTerms]),
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter: multiguard([Guard.preventLoginAccessIfLoggedIn]),
    },
    {
        path: '/password/reset',
        name: 'PasswordReset',
        component: PasswordReset,
        beforeEnter: multiguard([Guard.preventLoginAccessIfLoggedIn]),
    },
    {
        path: '/password/reset/:token',
        name: 'PasswordResetFinal',
        component: PasswordResetFinal,
        beforeEnter: multiguard([Guard.preventLoginAccessIfLoggedIn]),
    },
    {
        path: '/stringer',
        component: StringerLayout,
        redirect: '/stringer/dashboard', // to prevent user from landing on blank page
        beforeEnter: multiguard([Guard.auth, Guard.checkPermissionsVideographer, Guard.verifyUserNotSuspended, Guard.verifyUserAcceptedTerms]),
        children: [
            {
                path: 'dashboard',
                name: 'StringerDashboard',
                component: StringerDashboard,
            },
            {
                path: 'upload',
                name: 'StringerUpload',
                component: StringerUpload
            },
            {
                path: 'announcements',
                name: 'StringerAnnouncements',
                component: StringerAnnouncements
            },
            {
                path: 'announcements/:uuid',
                name: 'StringerAnnouncementView',
                component: StringerAnnouncementView
            },
            {
                path: 'videos',
                name: 'StringerVideos',
                component: StringerVideos
            },
            {
                path: 'photos',
                name: 'StringerPhotos',
                component: StringerPhotos
            },
            {
                path: 'sales',
                name: 'StringerSales',
                component: StringerSales
            },
            {
                path: 'settings',
                name: 'StringerSettings',
                component: StringerSettings
            },
            {
                path: 'lsc',
                name: 'StringerLiveStormChasing',
                component: StringerLiveStormChasing
            },
            {
                path: 'support/tickets',
                name: 'StringerSupportTickets',
                component: StringerSupportTickets
            },
            {
                path: 'support/tickets/new',
                name: 'StringerSupportCreateTicket',
                component: StringerSupportCreateTicket
            },
            {
                path: 'support/tickets/:id', // id = video id
                name: 'StringerSupportViewTicket',
                component: StringerSupportViewTicket,
            },
            {
                path: 'lsc/callback',
                name: 'StringerLscOauthCallback',
                component: StringerOauth,
            }
        ],
    },
    {
        path: '/admin',
        component: AdminLayout,
        redirect: '/admin/dashboard', // to prevent user from landing on blank page
        beforeEnter: multiguard([Guard.auth, Guard.checkPermissionsAdministrator, Guard.verifyUserNotSuspended, Guard.verifyUserAcceptedTerms]),
        children: [
            {
                path: 'dashboard',
                name: 'AdminDashboard',
                component: AdminDashboard
            },
            {
                path: 'upcoming',
                name: 'AdminUpcoming',
                component: AdminUpcoming
            },
            {
                path: 'video-manager',
                name: 'AdminVideoManager',
                component: AdminVideoManager
            },
            {
                path: 'users',
                name: 'AdminUsers',
                component: AdminUsers
            },
            {
                path: 'users/active',
                name: 'AdminActiveUsers',
                component: AdminActiveUsers
            },
            {
                path: 'users/:id',
                name: 'AdminUserDetails',
                component: AdminUserDetails,
            },
            {
                path: 'tools/announcements',
                name: 'AdminAnnouncements',
                component: AdminAnnouncements,
            },
            {
                path: 'tools/announcements/:id',
                name: 'AdminAnnouncement',
                component: AdminAnnouncement,
            },
            {
                path: 'sales/add',
                name: 'SalesAdd',
                beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
                component: AdminVideoAddSale
            },
            {
                path: 'sales/search',
                name: 'SalesSearch',
                beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
                component: AdminVideoSearchSale
            },
            {
                path: 'sales/pending',
                name: 'SalesPending',
                beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
                component: AdminVideoSalesPending
            },
            {
                path: 'sales/processing',
                name: 'SalesProcessing',
                beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
                component: AdminVideoSalesProcessing
            },
            {
                path: 'sales/completed',
                name: 'SalesCompleted',
                beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
                component: AdminVideoSalesCompleted
            },
            {
                path: 'tools',
                name: 'Tools',
                component: AdminTools
            },
            {
                path: 'tools/servers',
                name: 'UploadServers',
                component: AdminToolsUploadServers
            },
            {
                path: 'tools/networks',
                name: 'AdminNetworkManager',
                component: AdminNetworkManager
            },
            {
                path: 'tools/auto-approval-system',
                name: 'AdminAutoApprovalSystem',
                component: AdminAutoApprovalSystem
            },
            {
                path: 'support/tickets',
                name: 'AdminSupportTickets',
                component: AdminSupportTickets
            },
            {
                path: 'support/tickets/:id',
                name: 'AdminSupportIndividualTicket',
                component: AdminSupportIndividualTicket
            },
            {
                path: 'support/knowledge-base',
                name: 'AdminSupportKnowledgeBase',
                component: AdminSupportKnowledgeBase
            },
        ],
    },
    {
        path: '/admin',
        component: AdminFullWidthLayout,
        beforeEnter: multiguard([Guard.auth, Guard.checkPermissionsAdministrator, Guard.verifyUserNotSuspended, Guard.verifyUserAcceptedTerms]),
        children: [
            {
                path: 'tools/email-generator',
                name: 'MediaMailer',
                component: AdminToolsMediaMailer
            },
        ],
    },
    {
        path: '/account/finalize',
        component: AccountSetupLayout,
        redirect: '/account/finalize/terms', // to prevent user from landing on blank page
        beforeEnter: multiguard([Guard.auth, Guard.verifyUserNotSuspended]),
        children: [
            {
                path: 'terms',
                name: 'FinalizeTerms',
                component: FinalizeTerms
            },
            {
                path: 'account',
                name: 'FinalizeAccount',
                component: FinalizeAccount
            },
            {
                path: 'about',
                name: 'FinalizeAbout',
                component: FinalizeAbout
            },
            {
                path: 'social',
                name: 'FinalizeSocial',
                component: FinalizeSocial
            },
            {
                path: 'complete',
                name: 'FinalizeComplete',
                component: FinalizeComplete
            },
        ],
    },
    {
        path: '/changelog',
        name: 'ChangeLog',
        component: ChangeLog
    },
    {
        path: '/metrics',
        name: 'Metrics',
        component: Metrics,
        beforeEnter: multiguard([Guard.auth, Guard.checkPermissionsVideographer, Guard.verifyUserNotSuspended, Guard.verifyUserAcceptedTerms]),
    },
    {
        path: '/media/preview/:videoId/:refId', // id = video id
        name: 'MediaPreviewV2',
        component: MediaPreviewV2,
    },
    {
        path: '/media/preview/:id', // id = video id
        name: 'MediaPreview',
        component: MediaPreview,
    },
    {
        path: '/media/stream/:chaserId',
        component: MediaStreamPlayer,
        beforeEnter: multiguard([Guard.auth, Guard.checkPermissionsMedia, Guard.verifyUserNotSuspended, Guard.verifyUserAcceptedTerms]),
    },
    {
        path: '/media',
        component: MediaLayout,
        redirect: '/media/latest', // to prevent user from landing on blank page
        beforeEnter: multiguard([Guard.auth, Guard.checkPermissionsMedia, Guard.verifyUserNotSuspended, Guard.verifyUserAcceptedTerms]),
        children: [
            {
                path: 'latest',
                name: 'MediaLatestContent',
                component: MediaLatestContent
            },
            {
                path: 'search',
                name: 'MediaSearchContent',
                component: MediaSearchContent
            },
            {
                path: 'purchases',
                name: 'MediaPurchases',
                component: MediaPurchases
            },
            {
                path: 'members',
                name: 'MediaMembers',
                component: MediaMembers
            },
        ],
    },
    {
        path: '/chasers/wall',
        redirect: '/media/streams-wall',
    },

]
